import React from 'react';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../../lib/custom-scrollbar/custom-scrollbar';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEIcon from '../../../elements/oe-icon';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import retardUpdate from '../../../../lib/react/update-retarder';
import {OEGroupControl, OEIconButtonGroupControl} from '../../../elements/controls/oe-controls';
import {OEPopoverMenuButton} from '../../../views/oe-popover-menu';
import {OESmartAttributeChangeFlags, OESmartAttributeProps} from './oe-smart-attribute-model';
import OESmartAttributeCell from './oe-smart-attribute-cell';
import {OEFunctionPopoverController} from '../function/oe-function-controller';

export default class OESmartAttributeController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.attributes = Array.isArray(this.props.attributes) ? this.props.attributes : [];

        this.state = {
            addAttributeMenuEntries:    this.constructAddAttributeMenuEntries(),
            attributes:                 this.attributes,
            attrEventFuncEdit:          null,
            strings: {
                groupLabel:             '',
                btnGroupLabel:          ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onAddAttributeMenuRef = this.onAddAttributeMenuRef.bind(this);

        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onAddAttributeMenuSelection = this.onAddAttributeMenuSelection.bind(this);

        this.onDumpAttributeBtnPressed = this.onDumpAttributeBtnPressed.bind(this);
        this.onAttributeEventFuncBtnPressed = this.onAttributeEventFuncBtnPressed.bind(this);

        this.onAttributeChange = this.onAttributeChange.bind(this);
        this.onFunctionChange = this.onFunctionChange.bind(this);

        this.onFunctionPopoverToggle = this.onFunctionPopoverToggle.bind(this);
    }

    constructAddAttributeMenuEntries(props) {
        props = props || this.props;
        if(!Array.isArray(props.addAttributeMenuTypes))    return [];

        let entries = [];
        props.addAttributeMenuTypes.forEach(element => {

            if(typeof(element) == 'number') {
                element = {type: element};
            } else if(typeof(element) !== 'object' || !element)  {
                return;
            }

            //
            let allowMultipleInstances = element.allowMultipleInstances !== undefined ? element.allowMultipleInstances : true;

            //
            if(!allowMultipleInstances && this.attributes.findIndex(attribute => attribute.type === element.type) >= 0)  return;

            //
            let incompatibleTypes = typeof(element.incompatibleTypes) === 'number' ? [element.incompatibleTypes] : element.incompatibleTypes;

            if(Array.isArray(incompatibleTypes) && this.attributes.findIndex(attribute => incompatibleTypes.includes(attribute.type)) >= 0)  return;

            //
            entries.push({
                id:     element.type,
                icon:   this.iconForType(props, element.type)
            });
        });

        return entries;
    }

    getAttribute(id)   {
        return this.attributes.find((attribute) => attribute.id === id);
    }

    getAttributeEvent(id, event)    {
        if(typeof(event) !== 'number' || event < 0) return;
        let attribute = this.getAttribute(id);
        if(!attribute)  return;
        return event < attribute.events.length ? attribute.events[event] : undefined;
    }

    iconForType(props, type)  {
        props = props || this.props;
        return props.iconForType(type);
    }

    componentWillReceiveProps(nextProps)    {
        retardUpdate(this, () => {
            let needsAddAttributeMenuEntriesUpdate = false;

            if(!OEToolbox.shallowEqual(nextProps.attributes, this.props.attributes, true))    {
                let attributes = Array.isArray(nextProps.attributes) ? nextProps.attributes : [];

                if(!OEToolbox.shallowEqual(attributes, this.attributes, true))    {
                    this.attributes = attributes;
                    this.setState({attributes: this.attributes});
                }

                if(this.state.attrEventFuncEdit)    {
                    this.updateAttrEventFuncEdit(this.state.attrEventFuncEdit);
                }

                needsAddAttributeMenuEntriesUpdate = true;
            }

            if(!needsAddAttributeMenuEntriesUpdate && !OEToolbox.shallowEqual(nextProps.addAttributeMenuTypes, this.props.addAttributeMenuTypes) || nextProps.iconForType !== this.props.iconForType) {
                needsAddAttributeMenuEntriesUpdate = true;
            }

            if(needsAddAttributeMenuEntriesUpdate)  {
                this.updateAddAttributeMenuEntriesState(nextProps);
            }
        });
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateAddAttributeMenuEntriesState(props) {
        let addAttributeMenuEntries = this.constructAddAttributeMenuEntries(props);
        this.setState({addAttributeMenuEntries: addAttributeMenuEntries});
        if(!addAttributeMenuEntries.length && this.addAttributeMenuRef)   this.addAttributeMenuRef.close();
    }

    updateAttrEventFuncEdit(attrEventFuncEdit)  {

        if(attrEventFuncEdit)   {
            attrEventFuncEdit = clone(attrEventFuncEdit);

            let event = this.getAttributeEvent(attrEventFuncEdit.id, attrEventFuncEdit.event);
            if(!event || !event.function)  {
                attrEventFuncEdit = null;
            } else {
                attrEventFuncEdit.function = event.function;
            }
        }

        this.setState({attrEventFuncEdit: attrEventFuncEdit});
    }

    updateLanguage()   {
        if(!this.oe.isReady())  return;

        this.setState({
            strings: {
                groupLabel:         this.oe.sharedInterface.getLocalizedStringEnc('smart_attribute_view_group'),
                //btnGroupLabel:    this.oe.sharedInterface.getLocalizedStringEnc('smart_attribute_view_btn_group'),
            }
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released)   {
            return;
        }

        this.updateLanguage();
    }

    onAddAttributeMenuRef(ref)  {
        this.addAttributeMenuRef = ref;
    }

    renderAttributes()   {
        if(!this.state.attributes.length)    return null;

        return this.state.attributes.map((attribute, index) => 
            <OESmartAttributeCell
                key={attribute.id}
                moduleId={this.props.moduleId}
                popoverClassName="with-backdrop"
                boundariesElement={this.props.boundariesElement}
                showSeparator={index < this.state.attributes.length - 1}
                disabled={this.props.disabled}
                attribute={attribute}
                eventFuncButtonActivated={this.state.attrEventFuncEdit && attribute.id === this.state.attrEventFuncEdit.id ? this.state.attrEventFuncEdit.event : -1}
                iconForType={this.props.iconForType}
                parameterModelForType={this.props.parameterModelForType}
                onChange={this.onAttributeChange}
                onDumpBtnPressed={this.props.onAttributeRemoveRequest ? this.onDumpAttributeBtnPressed : null}
                onEventFuncBtnPressed={this.onAttributeEventFuncBtnPressed}
            />
        );
    }
    
    render() {

        return  (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={'smart-attribute-controller ' + this.props.className}>

                    <OEGroupControl 
                        className="smart-attribute-controller-group-control-1"
                        title={this.state.strings.groupLabel}
                    >

                        <OEIconButtonGroupControl
                            className="attribute-controller-buttons"
                            title={this.state.strings.btnGroupLabel}
                            disabled={this.props.disabled}
                            buttons={[]}
                            onPressed={this.onButtonPressed}
                        >
                            <OEPopoverMenuButton
                                className="transparent-btn last"
                                popoverClassName="with-backdrop"
                                controllerClassName="add-smart-attribute-menu"
                                placement="right"
                                boundariesElement={this.props.boundariesElement}
                                hideArrow={false}
                                buttonClassName="transparent-btn smart-attribute-type"
                                disabled={!this.state.addAttributeMenuEntries.length}
                                entries={this.state.addAttributeMenuEntries}
                                onChange={this.onAddAttributeMenuSelection}
                                ref={this.onAddAttributeMenuRef}
                            >
                                <OEIcon code={OEIconCodes.smartAttribute.addAttribute}/>
                            </OEPopoverMenuButton>

                        </OEIconButtonGroupControl>

                    </OEGroupControl>

                    <CustomScrollbar
                        className="smart-attribute-container"
                        horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                        verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                    >
                        {this.renderAttributes()}
                    </CustomScrollbar>

                </div>

                <OEFunctionPopoverController
                    moduleId={this.props.moduleId}
                    className="with-backdrop"
                    headerClassName="widget-header-small"
                    boundariesElement={this.props.boundariesElement}
                    target={this.state.attrEventFuncEdit ? this.state.attrEventFuncEdit.popoverTargetId : this.props.popoverTargetId}
                    placement="right"
                    isOpen={!!this.state.attrEventFuncEdit}
                    titleId="smart_attribute_event_function"
                    disabled={this.props.disabled}
                    onToggle={this.onFunctionPopoverToggle}
                    backdrop={false}
                    backdropOptions={{color: 'rgba(0, 0, 0, 0)'}}
                    targetReplacementWorkaround={true}
                    devFeatures={this.props.devFeatures}
                    addFragmentMenuTypes={this.props.addEventFunctionMenuTypes}
                    func={this.state.attrEventFuncEdit ? this.state.attrEventFuncEdit.function : undefined}
                    onChange={this.onFunctionChange}
                />
            </React.Fragment>
        );
    }

    onButtonPressed(sender, id)   {
    }

    onAddAttributeMenuSelection(id)    {
        if(this.addAttributeMenuRef) this.addAttributeMenuRef.close();

        if(this.props.onAttributeAddRequest)        this.props.onAttributeAddRequest(this, id);
    }

    onDumpAttributeBtnPressed(sender, id) {
        if(this.props.onAttributeRemoveRequest)     this.props.onAttributeRemoveRequest(this, id);
    }

    onAttributeEventFuncBtnPressed(sender, id, eventIndex, buttonPopoverTargetId)  {
        let prevAttrFuncEdit = this.state.attrEventFuncEdit;
        let attrEventFuncEdit = {id: id, event: eventIndex, popoverTargetId: buttonPopoverTargetId};
        if(prevAttrFuncEdit && prevAttrFuncEdit.id === attrEventFuncEdit.id && prevAttrFuncEdit.event === attrEventFuncEdit.event)  {
            attrEventFuncEdit = null;
        }

        this.updateAttrEventFuncEdit(attrEventFuncEdit);
    }

    onAttributeChange(sender, attribute, changeFlags, event) {
        if(this.props.onAttributeChangeRequest)     this.props.onAttributeChangeRequest(this, attribute, changeFlags, event);
    }

    onFunctionChange(sender, func)    {
        if(!this.state.attrEventFuncEdit)   return;

        let attribute = this.getAttribute(this.state.attrEventFuncEdit.id);
        if(!attribute)  return;
        if(this.state.attrEventFuncEdit.event < 0 || this.state.attrEventFuncEdit.event >= attribute.events.length) return;

        attribute = clone(attribute);
        attribute.events[this.state.attrEventFuncEdit.event].function = func;

        if(this.props.onAttributeChangeRequest)     this.props.onAttributeChangeRequest(this, attribute, OESmartAttributeChangeFlags.eventFunc, this.state.attrEventFuncEdit.event);
    }

    onFunctionPopoverToggle()  {
        this.setState({attrEventFuncEdit: null});
    }
}

OESmartAttributeController.defaultProps = OESmartAttributeProps.defaultProps;

OESmartAttributeController.propTypes = OESmartAttributeProps.propTypes;